export default "__VITE_ASSET__$Lfp8Nfi__"